import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentPreferencesComponent } from '@shared/components/document-preferences/document-preferences.component';

@Component({
  selector: 'app-document-preferences-page',
  templateUrl: 'document-preferences-page.component.html',
  styleUrls: ['document-preferences-page.component.scss'],
  imports: [DocumentPreferencesComponent],
})
export class DocumentPreferencesPageComponent {
  public readonly location = inject(Location);
  public readonly router = inject(Router);
}
